var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"vertical-center"},[_c('div',{staticClass:"col-lg-offset-12 col-lg-12 col-md-offset-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"panel panel-default country-select-panel text-center"},[_vm._m(0),_c('div',{staticClass:"panel-body"},[_c('login-form')],1)])])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"panel-heading"},[_c('h3',[_vm._v("Survey")])])
}]

export { render, staticRenderFns }